import { render, staticRenderFns } from "./TkHotelCard.vue?vue&type=template&id=076066bc&"
import script from "./TkHotelCard.vue?vue&type=script&lang=js&"
export * from "./TkHotelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports